import React from 'react';
import styled from 'styled-components';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
interface PaginationProps {
  totalItems: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const PaginationContainer = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  gap: 15px;
  align-items: center;
`;

const PaginationItem = styled.li`
  &.active button {
    color: #8e9697;
  }
`;

const PaginationButton = styled.button`
  text-decoration: none;
  color: #0751c2;
  padding: 8px 12px;
  border-radius: 5px;
  background: none;
  font-size: 16px;
  cursor: pointer;
  &:hover {
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;

const Img = styled.img`
  width: 32px;
  vertical-align: middle;
  height: 100%;
  &.left {
    transform: rotate(180deg);
  }
`;

const Pagination: React.FC<PaginationProps> = ({ totalItems, pageSize, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  const pages: Array<number | string> = [];

  if (totalPages <= 4) {
    pages.push(...Array.from({ length: totalPages }, (_, i) => i + 1));
  } else {
    pages.push(1);
    if (currentPage > 3) pages.push('...');

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 2) pages.push('...');
    pages.push(totalPages);
  }

  return (
    <PaginationContainer>
      <PaginationItem>
        <PaginationButton
          onClick={() => {
            onPageChange(currentPage - 1);
          }}
          disabled={currentPage === 1}
        >
          <Img className="left" src={`${publicRuntimeConfig.ASSETS_PREFIX}/images/icons/paggination_arrow.png`} />
        </PaginationButton>
      </PaginationItem>
      {pages.map((page, index) => (
        <PaginationItem key={index} className={currentPage === page ? 'active' : ''}>
          {typeof page === 'number' ? (
            <PaginationButton
              onClick={() => {
                onPageChange(page);
              }}
            >
              {page}
            </PaginationButton>
          ) : (
            <span>{page}</span>
          )}
        </PaginationItem>
      ))}
      <PaginationItem>
        <PaginationButton
          onClick={() => {
            onPageChange(currentPage + 1);
          }}
          disabled={currentPage === totalPages}
        >
          <Img src={`${publicRuntimeConfig.ASSETS_PREFIX}/images/icons/paggination_arrow.png`} />
        </PaginationButton>
      </PaginationItem>
    </PaginationContainer>
  );
};

export default Pagination;
